<div class="container-fluid">
  <app-main-navbar></app-main-navbar>
  <div class="row row-buttons">
    <div class="col-12 top-buttons mt-3 mb-5">
      <button class="btn main-buttons"
        [ngClass]="{ 'active': thematic_search_type === 'theme_definer' }"
        (click)="selectThemeSearchType('theme_definer')">
        Theme Definer
      </button>

      <button class="btn main-buttons"
        [ngClass]="{ 'active': thematic_search_type === 'theme_catalogue' }"
        (click)="selectThemeSearchType('theme_catalogue')">
        Themes Catalogue
      </button>

      <button class="btn main-buttons"
        [ngClass]="{ 'active': thematic_search_type === 'custom_search' }"
        (click)="selectThemeSearchType('custom_search')">
        Advanced Mode
      </button>
    </div>
  </div>

  <div class="row card-row">
    <div *ngIf="thematic_search_type === 'theme_catalogue'">
      <app-theme-catalogue></app-theme-catalogue>
    </div>

    <div *ngIf="thematic_search_type === 'custom_search'">
      <app-custom-search></app-custom-search>
    </div>

    <div class="col-12 card-col" *ngIf="thematic_search_type === 'theme_definer'">
      <div class="card shadow" style="background:#FFFFFF;">

        <!-- CHANGED TEXT START -->
        <p class="section-title">Describe the technology area you want to analyse</p>
        <!-- CHANGED TEXT END -->

        <div class="d-flex align-items-top gap-2 mb-3">
          <input
            [formControl]="user_input"
            type="text"
            class="form-control"
            placeholder="Describe a specific technology, application, or system">

          <div *ngIf="isLoading" class="spinner-container d-flex justify-content-center align-items-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>

          <button
            class="btn search-button"
            (click)="defineTheme()"
            [disabled]="!user_input.value || isLoading"
            style="background:#1E3A8A;color:#FFFFFF;">
            Search
          </button>
        </div>

        <!-- CHANGED TEXT START -->
        <div *ngIf="isThemeEmpty" class="alert alert-warning mt-2 p-2">
          We couldn’t generate a theme from this description. Additional detail can help improve the results.
        </div>
        <!-- CHANGED TEXT END -->

        <!-- Trending Shortcuts -->
        <div class="shortcuts-container mb-3" *ngIf="trendingThemes?.length">
          <p class="section-title">Example searches</p>
          <div class="shortcut-buttons">
            <button
              class="shortcut-btn"
              *ngFor="let item of trendingThemes; let i = index"
              style="background:#F1F5F9;color:#1F2937;"
              (click)="selectTrendingTheme(item)">
              {{ item.name }}
            </button>
          </div>
        </div>

        <!-- Recent Searches -->
        <div *ngIf="recentSearches.length > 0" class="recent-searches">
          <p class="section-title d-flex justify-content-between align-items-center"
             (click)="toggleRecent()">
            Recent Searches
            <span style="cursor: pointer;">{{ showRecent ? '▲' : '▼' }}</span>
          </p>

          <div *ngIf="showRecent">
            <div class="recent-item" *ngFor="let search of recentSearches; let i = index">
              <span class="clock-icon">{{ icons[i % icons.length] }}</span>
              <span class="search-text truncate-tooltip"
                    (click)="setSearch(search)">
                {{ search }}
              </span>
              <span class="close-icon" (click)="removeRecent(search)">✕</span>
            </div>
          </div>
        </div>

        <!-- Result -->
        <div *ngIf="theme && !isThemeEmpty && !isLoading && !transitioning" class="mt-3">
          <h5 class="card-title">Theme Generated</h5>
          <p class="card-text">{{ theme }}</p>
        </div>

        <div *ngIf="theme && !isThemeEmpty && !isLoading && transitioning" class="mt-3 text-center">
          <div class="spinner-border text-primary" role="status"></div>
          <p class="mt-2">Loading results...</p>
        </div>

      </div>
    </div>
  </div>
</div>
